module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-24.960eae3c.png";